import React from "react";

/**
 * A reusable module for "References & Further Reading."
 * Receives an array of references (each either a link or plain text).
 *
 * Props:
 * - referencesData (Array): List of references.
 *   Each item can have { url, label } for link-based references
 *   or { text } for plain-text references.
 * - headingId (string): The HTML id for the heading (optional).
 * - headingText (string): The heading text to display (optional).
 */
const References = ({
  referencesData = [],
}) => {
  const headingId = "references";
  const headingText = "References & Further Reading";
  return (
    <section className="references-section">
      <h2 id={headingId} className="references-heading">
        {headingText}
      </h2>
      <ul className="references-list">
        {referencesData.map((ref, idx) => (
          <li key={idx} className="references-list-item">
            {/* If the item has a URL, render it as a link; otherwise use plain text */}
            {ref.url ? (
              <a
                href={ref.url}
                target="_blank"
                rel="noopener noreferrer"
                className="reference-link"
              >
                {ref.label}
              </a>
            ) : (
              ref.text
            )}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default References;